/**
 * LE CIMETIÈRE — public, et c'est tout l'intérêt (§Q21).
 *
 * Pas de classement, pas de « meilleur score » : une liste de noms et de causes. C'est la promesse
 * de permadeath rendue vérifiable — et c'est aussi, pour un joueur qui hésite à s'inscrire, la
 * chose la plus honnête qu'on puisse lui montrer.
 */
import { useRessource } from "../api/chargement.js";
import type { DefuntEnVue } from "../api/types.js";
import { Sceau } from "../composants/Sceau.js";
import { ARCHETYPES } from "../lexique/mots.js";
import { t } from "../lexique/langue.js";

export function Cimetiere() {
  const { donnees, enCours } = useRessource<DefuntEnVue[]>(
    "/public/cimetiere",
    (charge: { heros: DefuntEnVue[] }) => charge.heros
  );
  const morts = donnees ?? [];

  return (
    <div className="page page--etroite arrivee">
      <header className="entete-decran entete-decran--centre">
        <Sceau empreinte="mort" taille={72} titre={t("Sceau du cimetière")} />
        <h1>{t("Le cimetière")}</h1>
        <p className="douce">
          {t("Ceux qui ne sont pas revenus. Chacun n'a eu qu'une vie, comme vous n'en aurez qu'une : aucun de ces noms ne s'effacera.")}
        </p>
      </header>

      {enCours ? <p className="faible">{t("On ouvre le registre…")}</p> : null}

      {!enCours && !morts.length ? (
        <p className="douce">{t("Personne n'est encore tombé. Ça ne durera pas.")}</p>
      ) : null}

      <ul className="epitaphes epitaphes--grandes">
        {morts.map((mort, index) => (
          <li key={`${mort.nom}-${index}`}>
            <span className="epitaphes__nom">{mort.nom}</span>
            <span className="capitales">{ARCHETYPES[mort.archetype]?.nom ?? mort.archetype}</span>
            <span className="douce">{mort.cause ?? "cause inconnue"}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
